import React from "react";

export default function CalendlyTextWidget() {
  return (
    <div className="booking-link">
      <a href="https://calendly.com/radiantlighthealing2024/30min" className="button-primary" onClick={(event) => {
        if (window.Calendly?.initPopupWidget) {
          event.preventDefault();
          window.Calendly.initPopupWidget({ url: "https://calendly.com/radiantlighthealing2024/30min" });
        }
      }}>Schedule an appointment <span aria-hidden="true">↗</span></a>
      <p>Choose a time that feels right for you.</p>
    </div>
  );
}
